// extracted by mini-css-extract-plugin
export default {"titleBlock":"MIv_ggt43aAzUTwWhnDh"};